<template>
  <form novalidate>
    <div class="rounded border shadow py-3">
      <div id="rotation-settings" class="rotation-settings d-flex flex-wrap">
        <p class="rotation-settings__title col-md-12">{{'rotation.write_names_for_stimulus' | trans}}</p>

        <div class="form-group col-md-12 col-lg-4">
          <mdc-textfield v-model="form[0]"
                         name="firstStimul"
                         :class="{'is-invalid': errors.has('firstStimul')}"
                         type="text"
                         :disabled="tableWasBuild"
                         v-validate="'required|check-unique'"
                         data-vv-validate-on="none"
                         :data-vv-as="'rotation.stimulus_one' | trans"
                         :label="'rotation.stimulus_one' | trans"/>
          <span class="invalid-feedback" v-if="errors.has('firstStimul')">
              {{ errors.first('firstStimul') }}
            </span>
        </div>

        <div class="form-group col-md-12 col-lg-4">
          <mdc-textfield v-model="form[1]"
                         name="secondStimul"
                         :class="{'is-invalid': errors.has('secondStimul')}"
                         type="text"
                         :disabled="tableWasBuild"
                         v-validate="'required|check-unique'"
                         data-vv-validate-on="none"
                         :data-vv-as="'rotation.stimulus_two' | trans"
                         :label="'rotation.stimulus_two' | trans"/>
          <span class="invalid-feedback" v-if="errors.has('secondStimul')">
              {{ errors.first('secondStimul') }}
            </span>
        </div>

        <div class="form-group col-md-12 col-lg-4">
          <mdc-textfield v-model="form[2]"
                         name="thirdStimul"
                         :class="{'is-invalid': errors.has('thirdStimul')}"
                         type="text"
                         :disabled="tableWasBuild"
                         v-validate="'required|check-unique'"
                         data-vv-validate-on="none"
                         :data-vv-as="'rotation.stimulus_three' | trans"
                         :label="'rotation.stimulus_three' | trans"/>
          <span class="invalid-feedback" v-if="errors.has('thirdStimul')">
              {{ errors.first('thirdStimul') }}
            </span>
        </div>
      </div>
    </div>
    <div class="form group-row">
      <div class="text-left">
        <mdc-button type="submit"
                    id="rotation-setting__button"
                    class="button-primary col-sm-6 col-lg-4 mt-4"
                    v-if="tableWasBuild"
                    @click.prevent="destroyTable()"
                    :disabled="disabled">{{'rotation.destroy_table' | trans}}
        </mdc-button>

        <mdc-button type="submit"
                    id="rotation-setting__button"
                    class="button-primary col-sm-6 col-lg-4 mt-4"
                    v-else
                    @click.prevent="buildTable()"
                    :disabled="disabled">{{'rotation.build_table' | trans}}
        </mdc-button>
      </div>
    </div>

    <loader v-if="loaded"></loader>
  </form>
</template>

<script>
  import $ from 'jquery';
  import Constants from '../Constants';
  import Loader from '../../loader/components/Loader';
  import {mapState, mapActions, mapGetters} from 'vuex';
  import {Validator} from 'vee-validate';
  import lang from '../../../lang/translator';
  import cloneDeep from 'lodash/cloneDeep';
  import isEmpty from 'lodash/isEmpty'

  export default {
    data() {
      return {
        disabled: false,
        tableWasBuild: false,
        loaded: false,
        form: {},
        tempSessions: [],
        blocksLength: 9,
        blocksStimulusLength: 3,
        sessionsLength: 3,
      };
    },
    components: {Loader},
    computed: {
      ...mapState('rotation/session', [
        'stimuli',
        'sessions'
      ]),
      ...mapGetters('mobile', [
        'isMobile'
      ]),
    },
    created() {
      this.form = isEmpty(this.stimuli) ? ['','',''] : this.stimuli;

      Validator.extend('check-unique', {
        getMessage: attribute => lang.get('rotation.unique_stimulus', {attribute}),
        validate: () => {
          let uniqueCounter = 0;

          for (let i = 0; i < Object.keys(this.form).length; i++) {
            for (let j = 0; j < Object.keys(this.form).length; j++) {
              if (this.form[i] == this.form[j]) {
                uniqueCounter++;
              }
            }
          }

          return (uniqueCounter === Object.keys(this.form).length);
        }
      });
    },
    methods: {
      ...mapActions('rotation/session', [
        'setSettings',
        'setSessions',
        'setStartedAt',
        'setIsSaved',
      ]),
      async buildTable() {
        this.disabled = true;
        this.loaded = true;
        this.setSessions([]);

        let result = await this.$validator.validateAll();
        if (!result) {
          this.disabled = false;
          this.loaded = false;
          return;
        }
        this.setSettings(this.form);
        this.setStartedAt(Math.round((new Date()).getTime() / 1000));

        //create temp stimulus block for creating another
        let tempStimulus = [
          this.form[0],
          this.form[1],
          this.form[2]
        ];

        //for each sessions
        for (let k = 0; k < this.sessionsLength; k++) {
          //temp blocks for session
          let session = {
            index: k + 1,
            blocks: []
          };

          //for each blocks row
          for (let i = 0; i < this.blocksLength; i++) {
            //temp block for each blocks row
            let stimuli = [];

            let block = {
              index: i + 1,
              resultId: Constants.NO_ANSWER,
              stimuli: []
            };


            //for each stimulus create object and add to blocks
            for (let j = 0; j < this.blocksStimulusLength; j++) {
              stimuli[j] = {
                name: tempStimulus[j],
                position: j + 1,
                correct: false
              };
            }

            //shift stimulus by 1 in tempBlock
            tempStimulus.unshift(tempStimulus.pop());

            block.stimuli = stimuli;
            session.blocks[i] = block;
          }

          //add all blocks to each session
          this.tempSessions[k] = session;
        }

        //next go to setting active
        this.setActiveStimulus();
      },

      setActiveStimulus() {
        //for each sessions
        for (let k = 0; k < this.sessionsLength; k++) {
          //array with index of active items in row
          let firstStimulusByBlocks = [];
          let activeItems = [];


          //for each stimulus column
          for (let j = 0; j < this.blocksLength; j++) {
            let self = this;
            let itemIndex;


            if (j === 0) {
              //random number for checking active element in column
              let activeIndex = Math.floor(Math.random() * self.blocksStimulusLength);
              //set active
              self.tempSessions[k].blocks[j].stimuli[activeIndex].correct = true;

              //add to activeItems
              activeItems = activeItems.concat(activeIndex);
              itemIndex = activeIndex;
            }
            else if (j % 3 == 0){
              let newIndex = firstStimulusByBlocks[firstStimulusByBlocks.length - 1];

              switch (newIndex) {
                case 0:
                  this.tempSessions[k].blocks[j].stimuli[1].correct = true;
                  activeItems = activeItems.concat(1);
                  itemIndex = 1;
                  break;
                case 1:
                  this.tempSessions[k].blocks[j].stimuli[2].correct = true;
                  activeItems = activeItems.concat(2);
                  itemIndex = 2;
                  break;
                case 2:
                  this.tempSessions[k].blocks[j].stimuli[0].correct = true;
                  activeItems = activeItems.concat(0);
                  itemIndex = 0 ;
                  break;
              }
            }
            else {
              switch (activeItems[j-1]) {
                case 0:
                  this.tempSessions[k].blocks[j].stimuli[2].correct = true;
                  activeItems = activeItems.concat(2);
                  itemIndex = 2;
                  break;
                case 1:
                  this.tempSessions[k].blocks[j].stimuli[0].correct = true;
                  activeItems = activeItems.concat(0);
                  itemIndex = 0;
                  break;
                case 2:
                  this.tempSessions[k].blocks[j].stimuli[1].correct = true;
                  activeItems = activeItems.concat(1);
                  itemIndex = 1;
                  break;
              }
            }

            if (j % 3 == 0) {
              firstStimulusByBlocks = firstStimulusByBlocks.concat(itemIndex);
            }
          }
        }

        this.tableWasBuild = true;
        this.disabled = false;
        this.loaded = false;
        this.setSessions(this.tempSessions);
        this.setIsSaved(true);
        this.$emit('session-settings-set');

        if (this.isMobile) {
          $('html, body').animate({scrollTop: $("#rotation-setting__button").offset().top - 10}, 500);
        }
      },
      destroyTable()
      {
        this.tableWasBuild = false;
        this.disabled = false;
        this.setSessions([]);
        this.setIsSaved(false);
        this.$emit('session-settings-set');

        if (this.isMobile) {
          $('html, body').animate({scrollTop: $("#rotation-settings").offset().top - 25}, 500);
        }
      }
      ,
    }
  };
</script>


// WEBPACK FOOTER //
// src/modules/randomRotation/components/SettingsForm.vue